import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export const initDataDog = () => {
  if (!import.meta.env.VITE_DATA_DOG_APP_ID) {
    console.error('VITE_DATA_DOG_APP_ID not found')
    return
  }
  if (!import.meta.env.VITE_DATA_DOG_CLIENT_TOKEN) {
    console.error('VITE_DATA_DOG_CLIENT_TOKEN not found')
    return
  }

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATA_DOG_CLIENT_TOKEN,
    site: 'ap1.datadoghq.com',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100,
  })

  datadogRum.init({
    // get it from env
    applicationId: import.meta.env.VITE_DATA_DOG_APP_ID,
    clientToken: import.meta.env.VITE_DATA_DOG_CLIENT_TOKEN,
    site: 'ap1.datadoghq.com',
    service: 'ospace',
    env: import.meta.env.VITE_STAGE || 'local',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })
}
